import {
  merchantKnowledgeArticleSchema,
  merchantKnowledgeAvailabilitySchema,
  merchantKnowledgeDraftSchema,
} from "@redotech/shopper-agent-knowledge-common/merchant-knowledge-view";
import { suggestedMerchantKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";

/** Publishes the proposal as an article and reviews the suggestion onto it. */
export const acceptKnowledgeSuggestion = {
  name: "acceptKnowledgeSuggestion" as const,
  input: z
    .object({
      id: suggestedMerchantKnowledgeIdFormat.schema,
      /** Reviewer edits. The suggestion keeps its own copy either way. */
      overrides: merchantKnowledgeDraftSchema.partial().optional(),
      availability: merchantKnowledgeAvailabilitySchema.optional(),
    })
    .strict(),
  output: merchantKnowledgeArticleSchema,
};
